<template>
  <div class="sub-menu">
    <BaseLayout :title="title" @click-back="close" hasHeaderBar="true">
      <div class="text-left bg-light" v-if="functionPath.length">
        <span v-for="(path,i) in functionPath" :key="path">
          <span
            style="font-size:1rem"
            @click="goto(i)"
            class="text-info badge badge-light"
          >{{ path }}</span>
          <span v-if="i!=(functionPath.length-1)" class="text-info">></span>
        </span>
      </div>

      <ul class="list-group">
        <li
          v-for="(m) in menu"
          :key="m.childFunctionId"
          style="padding:0"
          class="list-group-item text-left"
        >
          <div
            :href="'#'+m.childFunctionId"
            @click="selectItem(m)"
            style="width:100%; height:100%;padding: .75rem 1.25rem;"
          >
            <b>
              <span class="badge badge-info">{{ m.childFunctionId }}</span>
              {{m.functionName}}
            </b>
            <i
              v-if="m.childNode.length==0"
              style="float:right; color:#e17055"
              class="fas fa-sign-in-alt"
            ></i>
            <i v-else class="far fa-folder-open" style="float:right;"></i>
          </div>

          <!-- <div v-if="m.selected">
            <SubMenu
              :menu="m.childNode"
              style="float:right;"
              :title="m.functionName"
              :functionPath="functionPath.concat(m.functionName)"
              :parent="m"
              :parentList="parentList.concat(m)"
              @childClose="childClose(m)"
          ></SubMenu>-->
          <!-- </div> -->
        </li>
      </ul>
    </BaseLayout>
  </div>
</template>
<script>
import { debuglog } from "util";
// import BaseLayout from "@/components/base/BaseLayout.vue";
export default {
  name: "SubMenu",
  data: function() {
    return { isClose: false };
  },
  components: {
    // BaseLayout: BaseLayout
  },
  data: function() {
    var _this = this;

    var functionIdList = this.$route.params.path.split("&");
    var targetFunctionList = _this.$store.state.menu;
    var parentList = [];
    var nameList = [].concat("MENU");
    for (var i = 0; i < functionIdList.length; i++) {
      // for (var f in functionIdList) {

      var t = targetFunctionList.find(
        x => x.childFunctionId == functionIdList[i]
      );
      if (t === undefined) {
        // history.pushState(null, null, location.href);
        _this.$router.replace("/");
      }
      nameList.push(t.functionName);
      parentList.push(t);
      targetFunctionList = t.childNode;
    }
    // function fn(functionId, list) {
    //   var t = list.find(x => x.childFunctionId == functionId);
    //   name = t.functionName;
    //   targetFunctionList = t.childNode;
    // }
    // debugger;
    return {
      menu: [],
      title: "",
      functionPath: [],
      parentList: []
    };
    // return {
    //   menu: targetFunctionList,
    //   title: nameList[nameList.length - 1],
    //   functionPath: nameList,
    //   parentList: parentList
    // };
  },
  // props: ["menu", "title", "functionPath", "parentList"],
  methods: {
    goto: function(i) {
      if (this.parentList[i].functionId == "CFMENU") {
        this.$router.push("/menu");
      } else {
        // for (var s = 1; s <= i; s++) {}
        this.$router.push(
          "/submenu/" +
            this.parentList
              .slice(1, i + 1)
              .map(x => x.functionId)
              .join("&")
        );
      }
      // if (i == this.functionPath.length) {
      // } else if (i == 0) {
      //   this.parentList.forEach(e => (e.selected = false));
      // } else {
      //   this.parentList
      //     .filter(function(item, index, array) {
      //       if (index > i - 1) {
      //         return item;
      //       }
      //     })
      //     .forEach(x => (x.selected = false));
      // }
    },
    childClose: function(m) {
      m.selected = false;
    },
    close: function() {
      this.$router.go(-1);
      // console.log(this.parentList);
      // alert(1);
      // this.parent.selected = false;
      // this.isClose = true;
      // this.$emit("childClose");
      // this.$destroy();
    },
    selectItem: function(m) {
      // debugger;
      if (m.childNode && m.childNode.length) {
        this.$router.push(
          "/submenu/" +
            this.parentList
              .map(x => x.childFunctionId)
              .concat(m.childFunctionId)
              .join("&")
        );
        m.selected = true;
      } else {
        // alert("set msg");
        // this.$router.push(m.url);
        let resolved = this.$router.resolve(m.url);
        if (resolved.route.name == "Error") {
          this.setMessageText("Requested page not found!");
        } else {
          this.setCurrentFunctionName(
            m.functionName +
              " " +
              `<span class="badge badge-secondary">${this.$store.state.companyId}</span>`
          );
          this.setCurrentFunctionId(m.childFunctionId);
          this.$router.push(m.url);
          // this.$router.replace(m.url);
        }
        // if (m.url) {
        //   this.$router.push(m.url);
        // } else this.setMessageText("No function");
      }
    }
  },
  watch: {
    "$route.params.path": {
      handler: function(path) {
        var _this = this;

        var functionIdList = this.$route.params.path.split("&");
        var targetFunctionList = _this.$store.state.menu;
        var parentList = [];
        var nameList = [].concat("MENU");
        for (var i = 0; i < functionIdList.length; i++) {
          var t = targetFunctionList.find(
            x => x.childFunctionId == functionIdList[i]
          );
          if (t === undefined) {
            _this.$router.replace("/");
          }
          nameList.push(t.functionName);
          parentList.push(t);
          targetFunctionList = t.childNode;
        }
        _this.menu = targetFunctionList;
        _this.title = nameList[nameList.length - 1];
        _this.functionPath = nameList;
        _this.parentList = parentList;
      },
      deep: true,
      immediate: true
    }
  },
  mounted: function() {
    this.setCurrentFunctionId(null);
    // alert(this.parentList.length);
    // alert(1);
  }
};
</script>

<style scoped>
.sub-menu {
  overflow: auto;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 9999;
  background: #fff;
}
/* Enter and leave animations can use different */
/* durations and timing functions.              */
.slide-fade-enter-active {
  transition: all 0.3s ease;
}
.slide-fade-leave-active {
  transition: all 0.2s cubic-bezier(1, 0.5, 0.8, 1);
}
.slide-fade-enter, .slide-fade-leave-to
/* .slide-fade-leave-active below version 2.1.8 */ {
  transform: translateX(10px);
  opacity: 0;
}
.list-group {
  /* margin: auto -15px; */
}
</style>